import React, { memo, useEffect } from "react"
import AOS from "aos"
import moment from "moment"
import parse from "html-react-parser"
import "aos/dist/aos.css"
import OptimizedImage from "../../ImageShow/OptimizedImage"
import SectionsTitle from "../../../Common/new/SectionsTitle"
import * as style from "./blog.module.css"
import {
  appNavigate,
  replaceUnderscoresWithSpaces,
} from "../../../utils/functions"
import LinkArrow from "../../svg/new/LinkArrow"

const Blog = ({
  CustomClass,
  homeBlogContent,
  homeBlogTitle,
  selectBlog,
  homeBlogShowSection,
  homeBlogSubTitle,
}) => {
  useEffect(() => {
    AOS.init({
      once: true,
    })
  }, [])

  const handleMainLinkClick = (e, nameSlug) => {
    e.preventDefault() // Prevent default link behavior if needed
    appNavigate(`/blogs/${nameSlug}`) // Redirect to the main link
  }

  // Function to handle author click
  const handleAuthorClick = (e, authorName) => {
    e.stopPropagation() // Prevent triggering parent link click
    if (authorName) {
      appNavigate(`/blogs/author/${authorName}`) // Call the author click handler
    }
  }

  return (
    <>
      {homeBlogShowSection === "yes" && (
        <section
          className={`${CustomClass}`}
          data-aos="fade-up"
          data-aos-delay="50"
        >
          <div className="container">
            <div className={style.blog_wrap}>
              <SectionsTitle
                title={replaceUnderscoresWithSpaces(homeBlogTitle)}
                SubTitle={homeBlogSubTitle}
                Content={homeBlogContent}
                btnName="View All"
                href="/blogs"
              />
            </div>
            <ul className={`${style.blog_listing}`}>
              {selectBlog?.map((it, ind) => {
                return (
                  <li key={ind}>
                    <div
                      className={style.links_div_box}
                      onClick={e => handleMainLinkClick(e, it?.slug)}
                    >
                      <div className={style.innerRoot}>
                        <OptimizedImage
                          imageData={
                            it?.featuredImage?.node?.mediaItemUrl
                              ? it?.featuredImage?.node?.mediaItemUrl
                              : "/images/placeholder-image.jpg"
                          }
                          alt={it?.featuredImage?.node?.altText}
                          pictureclass={style.picture}
                        />
                        <div className="infoDivbox">
                          <div className="wrapperTitle">
                            <ul className={`blog_dt_tmul ${style.ul_list}`}>
                              <li>
                                <div
                                  className={`blog_li ${style.tooltip}`}
                                  title={it?.categories?.nodes[0]?.name}
                                >
                                  {it?.categories?.nodes[0]?.name}
                                  {/* <span className={style.tooltiptext}>{it?.categories?.nodes[0]?.name}</span> */}
                                </div>
                              </li>
                              <li>
                                <div
                                  className="blog_li"
                                  title={moment(it?.date).format("DD MMM")}
                                >
                                  {moment(it?.date).format("DD MMM")}{" "}
                                </div>{" "}
                              </li>
                            </ul>
                          </div>
                          <h3>{parse(`${it?.title}`)} </h3>
                        </div>

                        {it?.singlePageFieldsNew?.authorName == null ? (
                          ""
                        ) : (
                          <div
                            className="blog_dt_tm"
                            onClick={e =>
                              handleAuthorClick(
                                e,
                                it?.singlePageFieldsNew?.authorName
                              )
                            }
                          >
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <div className={style.imgbox}>
                                <OptimizedImage
                                  imageData={
                                    it?.singlePageFieldsNew?.authorImage
                                      ?.mediaItemUrl
                                      ? it?.singlePageFieldsNew?.authorImage
                                          ?.mediaItemUrl
                                      : "/images/placeholder-image.jpg"
                                  }
                                  alt={it.singlePageFieldsNew?.authorName}
                                />
                              </div>
                              <div className={style.infoBox}>
                                <div className={style.infoName}>
                                  {" "}
                                  {it?.singlePageFieldsNew?.authorName}{" "}
                                </div>
                                <div className={style.infoDesig}>
                                  {it?.singlePageFieldsNew?.authorDesignation}
                                </div>
                              </div>
                            </div>
                            <i className="linkArrowIcon">
                              <LinkArrow />
                            </i>
                          </div>
                        )}
                      </div>
                    </div>
                  </li>
                )
              })}
            </ul>
          </div>
        </section>
      )}
    </>
  )
}

export default memo(Blog)
